
import { TerritoryPenaltyStatusEnum, TerritoryViolation } from '@/config/types';
import { getViolations } from '@/services/territory/get-violations';
import { generatePenalty } from '@/services/territory/generate-penalty';
import HeaderInternal from '@/components/HeaderInternal/index.vue';
import getTerritoryByCarCodeService from '@/services/territory/get-territory-by-car-code';
import postPenalty from '@/services/tickets/post-penalty';
// import getTerritoryPenaltyStatus from '@/services/territory/get-territory-penalty-status';
import Heading from '@/components/Heading/index.vue';
import PenaltyCard from '@/components/PenaltyCard/index.vue';
import updateTerritoryPenaltyStatus from '@/services/territory/update-territory-penalty-status';
import Vue from 'vue';
import { Container } from './styles';

export default Vue.extend({
  name: 'Penalty',
  components: {
    HeaderInternal,
    Container,
    PenaltyCard,
    Heading,
  },
  data() {
    return {
      territoryName: '',
      territoryId: '',
      territoryByCar: {
        loaded: false,
        aderiuPRA: '',
        area: '',
        condigo: '',
        dataAnalise: '',
        dataRegistro: '',
        dataRetificacao: '',
        latitude: '',
        longitude: '',
        modulosFiscais: '',
        statusImovel: '',
        condicaoAnalise: '',
        estado: '',
      },
      loaded: false,
      car: '',
      totalPenalty: {
        totalAmount: 0,
        cdTerritory: '',
        totalInstallments: 0,
      },
      territoryViolations: [] as TerritoryViolation[],
    };
  },
  methods: {
    async getData() {
      const { id, name, car } = this.$route.params;
      this.car = car;
      const { objectResult } = await getTerritoryByCarCodeService(this.car.trim().replaceAll('-', ''));
      if (objectResult) this.territoryByCar = objectResult.dadosExtratoPdf;
      this.territoryName = name;
      this.territoryId = id;
      this.territoryViolations = await this.getTerritoryViolations();
    },
    async getTerritoryViolations() {
      const dueDataRequest = this.generateDueDataRequest();
      return getViolations(dueDataRequest);
    },
    getFormData() {
      const data = this.territoryViolations;
      // eslint-disable-next-line no-param-reassign
      data.map((x) => x.violatedAreas.filter((violatedArea) => violatedArea.area === '').map((a) => { a.area = '0'; return a; }));
      return data;
    },
    async generateTerritoryPenalty() {
      /* eslint max-len: ["error", { "code": 199 }] */
      const loader = this.$loading.show({
        container: this.$refs.formContainer,
        canCancel: false,
      });
      this.loaded = false;
      const dueDataRequest = this.generateDueDataRequest();
      dueDataRequest.violationsToUpdate = this.getFormData();
      let result = null;
      result = await generatePenalty(dueDataRequest);
      if (result !== null) {
        await updateTerritoryPenaltyStatus(this.territoryId, TerritoryPenaltyStatusEnum.pendingPaymentReview)
          .then(() => {
            // @ts-ignore
            this.totalPenalty.totalAmount = result.data.objectResult.penaltyValue;
            this.totalPenalty.cdTerritory = this.$route.params.id;
            // @ts-ignore
            this.totalPenalty.totalInstallments = result.data.objectResult.totalInstallments;
            postPenalty(this.totalPenalty).then((e) => {
              Vue.swal('', e.message, 'success');
              this.$router.back();
            });
          });
        loader.hide();
      }
      this.loaded = true;
    },
    redirectToTerritoryDetailsPage(paymentValue, installments, documentData) {
      this.$router.push({ name: 'PaymentPay', params: { paymentValue, installments, documentData } }, () => {
        Vue.$toast.success('Operação realizada com exito!');
      });
    },
    generateDueDataRequest(): any {
      const userLogged = JSON.parse(sessionStorage.getItem('userLogged') as string);
      return {
        cdTerritory: this.territoryId,
        tokenKey: userLogged?.company?.stKey,
        fkUser: `${userLogged?.idUser.toString()}`,
        cdCompany: `${userLogged?.company.idCompany.toString()}`,
        cdAnalysis: `${process.env.VUE_APP_ANALISE}`,
        taxModules: this.territoryByCar.modulosFiscais.toString(),
      };
    },
  },
  /* beforeRouteEnter(to, from, next) {
    next(async (component) => {
      const territoryStatus = await getTerritoryPenaltyStatus(component.$route.params.id);
      if (territoryStatus?.id !== TerritoryPenaltyStatusEnum.pending) { next('/not-found'); }
    });
  }, */
  async created() {
    await this.getData();
    this.loaded = true;
  },
});
